<template lang="pug">
  Modal.searchModal(v-model='searchModal' closable footer-hide :styles="{width:'840px',height:'607px'}")
    iframe.ifrmae(src='https://www.baidu.com/' width='840px' height='607px' scrolling='yes' frameborder=0,onload="console.clear()",v-if="searchModal")
</template>

<script>
export default {
  name: "searchModal",
  data() {
    return {
      searchModal: false
    };
  }
};
</script>

<style lang="stylus">
.searchModal
  .ivu-modal-body
    padding 0
    padding-top 45px
  .ivu-modal-close
    background rgba(200, 200, 200, 0.5)
</style>
